import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, DialogProps, TextFieldProps } from '@mui/material';
import { useLang } from '../../contexts/langContext';

interface TextEditorDialogProps {
  onClose: () => void;
  onSave: (value: string) => void;
  initialValue: string;
  dialogProps?: Partial<DialogProps>;
  textFieldProps?: Partial<TextFieldProps>;
}

function TextEditorDialog({ onClose, onSave, initialValue, dialogProps, textFieldProps }: TextEditorDialogProps) {
  const { lang } = useLang();
  const [value, setValue] = useState(initialValue);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth {...dialogProps}>
      <DialogTitle>{lang === 'en' ? 'Edit Text' : '编辑文字'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={lang === 'en' ? 'Text Content' : '文本内容'}
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          {...textFieldProps}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{lang === 'en' ? 'Cancel' : '取消'}</Button>
        <Button onClick={() => onSave(value)} variant="contained">
          {lang === 'en' ? 'Save' : '保存'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TextEditorDialog;
